import React from 'react';
import styles from './banner.module.scss';
import AttentionIcon from 'public/images/attention.png';
import { useTranslation } from 'next-i18next';
import Box from 'src/components/ui-kit/box/box';
import Image from 'next/legacy/image';

export default function ListingsBanner({ type }: { type: string }): JSX.Element {
  const { t } = useTranslation('components:pages:listings:view:banner');

  return (
    <Box className={styles.banner}>
      <div className={styles.banner_icon}>
        <Image
          src={AttentionIcon}
          height={80}
          width={80}
          alt={t('TEXT_ATTENTION_ICON')}
          priority />
      </div>
      <div>
        <h4 className={styles.banner_title}>{t(`${type}.TEXT_BANNER_TITLE`)}</h4>
        <p>{t(`${type}.TEXT_BANNER_DESCRIPTION`)}</p>
      </div>
    </Box>
  );
}
